module.exports = __webpack_public_path__ + "tables/media/Forms_outlined.3c7fcbb8.svg";